import { Grid, GridRow, GridColumn } from 'semantic-ui-react';
import { usePermissions } from '~/requests/permissions/usePermissions';
import { Project } from '~/types/project';
import { DeploymentTypes, DeploymentTypeDisplay } from '~/constants/deployment-type';

export const KEY_DETAILS_GRID = 'project-key-details-grid-id';
interface KeyDetailsProps {
  project: Project;
  values: any;
  isEpcOperating: boolean;
}

export default function KeyDetails({
  project,
  values: projectDisplayValues,
  isEpcOperating
}: KeyDetailsProps) {
  const { permissions } = usePermissions();
  const { projectDetails } = projectDisplayValues || {};
  const { investor: projectInvestor } = project || {};

  const developer = projectDetails?.developer;
  const location = projectDetails?.location;
  const arrayTypes = projectDetails?.technologies?.arrayTypes;
  const interconnection = projectDetails?.interconnectionType;
  const pricingGoal = projectDetails?.pricingType;
  const offTakeValue = projectDetails?.offtakeRate?.value;
  const longTermOwner = projectDetails?.longTermOwner;
  const projectInvestorName = projectInvestor?.company?.name;
  const safeHarborStatus = 'ITC: ' + (project?.itcDetails?.safeHarboredForItc === null ? 'TBD' : project?.itcDetails?.safeHarboredForItc ? 'Yes' : 'No') + ' | FEOC: ' + (project?.itcDetails?.safeHarboredForFeoc === null ? 'TBD' : project?.itcDetails?.safeHarboredForFeoc ? 'Yes' : 'No');

  const displayOfftakeRate = projectDetails?.offtakeRate?.isDisplaying;
  const displayInvestor = projectInvestor && permissions.hasProjectDeveloperAccess;

  return (
    <Grid className="project-details-grid" stackable>
      {[
        displayInvestor && {
          label: 'Investor',
          value: projectInvestorName,
        },
        permissions.hasProjectInvestorAccess && {
          label: 'Developer',
          value: developer,
        },
        {
          label: permissions.hasProjectDeveloperAccess ? 'Bid type requested' : 'Pricing goal',
          value: pricingGoal,
        },
        {
          label: 'Location',
          value: location,
        },
        (project.projectArrays && project.projectArrays.length > 0) && {
          label: 'Array types',
          value: arrayTypes,
        },
        !isEpcOperating && (
          {
            label: 'Interconnection',
            value: interconnection,
          }
        ),
        {
          label: 'Long-term owner',
          value: longTermOwner,
        },
        {
          label: 'Deployment type',
          value: DeploymentTypeDisplay[DeploymentTypes[project.deploymentType || 'CI']],
        },
        (!isEpcOperating && project?.itcDetails?.isItcEligible) && (
          {
            label: 'Safe harbor status',
            value: safeHarborStatus,
          }
        ),
        displayOfftakeRate && {
          label: 'Offtake',
          value: offTakeValue,
        },
      ]
        .filter(Boolean)
        .map((item: any, idx: number) => (
          <GridRow key={idx}>
            <GridColumn width={3} className="project-label">
              <span>{item.label}</span>
            </GridColumn>
            <GridColumn width={9} className="project-value">
              <span>{item.value}</span>
            </GridColumn>
          </GridRow>
        ))}
    </Grid>
  );
}